/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTodayRouteImport } from './routes/_app/today'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppPondsRouteImport } from './routes/_app/ponds'
import { Route as AppOverviewRouteImport } from './routes/_app/overview'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppMapRouteImport } from './routes/_app/map'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppHarvestsRouteImport } from './routes/_app/harvests'
import { Route as AppFinancialsRouteImport } from './routes/_app/financials'
import { Route as AppFeedingsRouteImport } from './routes/_app/feedings'
import { Route as AppEditRequestsRouteImport } from './routes/_app/edit-requests'
import { Route as AppCyclesRouteImport } from './routes/_app/cycles'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppPondsIndexRouteImport } from './routes/_app/ponds.index'
import { Route as AppOcrIndexRouteImport } from './routes/_app/ocr/index'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory.index'
import { Route as AppImportIndexRouteImport } from './routes/_app/import/index'
import { Route as AppFinancialsIndexRouteImport } from './routes/_app/financials.index'
import { Route as AppEntryIndexRouteImport } from './routes/_app/entry/index'
import { Route as AppToolsFeedCalculatorRouteImport } from './routes/_app/tools/feed-calculator'
import { Route as AppPondsPondIdRouteImport } from './routes/_app/ponds.$pondId'
import { Route as AppOcrTestRouteImport } from './routes/_app/ocr/test'
import { Route as AppOcrJobIdRouteImport } from './routes/_app/ocr/$jobId'
import { Route as AppInventoryTransactionsRouteImport } from './routes/_app/inventory.transactions'
import { Route as AppInventoryItemsRouteImport } from './routes/_app/inventory.items'
import { Route as AppImportJobIdRouteImport } from './routes/_app/import/$jobId'
import { Route as AppFinancialsExpensesRouteImport } from './routes/_app/financials.expenses'
import { Route as AppFinancialsComparisonRouteImport } from './routes/_app/financials.comparison'
import { Route as AppEntryOverviewRouteImport } from './routes/_app/entry/overview'
import { Route as AppEntryBatchRouteImport } from './routes/_app/entry/batch'
import { Route as AppFinancialsCyclesCycleIdRouteImport } from './routes/_app/financials.cycles.$cycleId'
import { Route as AppEntryPondPondIdRouteImport } from './routes/_app/entry/pond.$pondId'
import { Route as AppEntryPondPondIdWaterRouteImport } from './routes/_app/entry/pond.$pondId.water'
import { Route as AppEntryPondPondIdSamplingRouteImport } from './routes/_app/entry/pond.$pondId.sampling'
import { Route as AppEntryPondPondIdHarvestRouteImport } from './routes/_app/entry/pond.$pondId.harvest'
import { Route as AppEntryPondPondIdFeedingRouteImport } from './routes/_app/entry/pond.$pondId.feeding'
import { Route as AppEntryPondPondIdApplicationRouteImport } from './routes/_app/entry/pond.$pondId.application'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppPondsRoute = AppPondsRouteImport.update({
  id: '/ponds',
  path: '/ponds',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppHarvestsRoute = AppHarvestsRouteImport.update({
  id: '/harvests',
  path: '/harvests',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancialsRoute = AppFinancialsRouteImport.update({
  id: '/financials',
  path: '/financials',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedingsRoute = AppFeedingsRouteImport.update({
  id: '/feedings',
  path: '/feedings',
  getParentRoute: () => AppRoute,
} as any)
const AppEditRequestsRoute = AppEditRequestsRouteImport.update({
  id: '/edit-requests',
  path: '/edit-requests',
  getParentRoute: () => AppRoute,
} as any)
const AppCyclesRoute = AppCyclesRouteImport.update({
  id: '/cycles',
  path: '/cycles',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppPondsIndexRoute = AppPondsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPondsRoute,
} as any)
const AppOcrIndexRoute = AppOcrIndexRouteImport.update({
  id: '/ocr/',
  path: '/ocr/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppImportIndexRoute = AppImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancialsIndexRoute = AppFinancialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFinancialsRoute,
} as any)
const AppEntryIndexRoute = AppEntryIndexRouteImport.update({
  id: '/entry/',
  path: '/entry/',
  getParentRoute: () => AppRoute,
} as any)
const AppToolsFeedCalculatorRoute = AppToolsFeedCalculatorRouteImport.update({
  id: '/tools/feed-calculator',
  path: '/tools/feed-calculator',
  getParentRoute: () => AppRoute,
} as any)
const AppPondsPondIdRoute = AppPondsPondIdRouteImport.update({
  id: '/$pondId',
  path: '/$pondId',
  getParentRoute: () => AppPondsRoute,
} as any)
const AppOcrTestRoute = AppOcrTestRouteImport.update({
  id: '/ocr/test',
  path: '/ocr/test',
  getParentRoute: () => AppRoute,
} as any)
const AppOcrJobIdRoute = AppOcrJobIdRouteImport.update({
  id: '/ocr/$jobId',
  path: '/ocr/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryTransactionsRoute =
  AppInventoryTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AppInventoryRoute,
  } as any)
const AppInventoryItemsRoute = AppInventoryItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppImportJobIdRoute = AppImportJobIdRouteImport.update({
  id: '/import/$jobId',
  path: '/import/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancialsExpensesRoute = AppFinancialsExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppFinancialsRoute,
} as any)
const AppFinancialsComparisonRoute = AppFinancialsComparisonRouteImport.update({
  id: '/comparison',
  path: '/comparison',
  getParentRoute: () => AppFinancialsRoute,
} as any)
const AppEntryOverviewRoute = AppEntryOverviewRouteImport.update({
  id: '/entry/overview',
  path: '/entry/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppEntryBatchRoute = AppEntryBatchRouteImport.update({
  id: '/entry/batch',
  path: '/entry/batch',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancialsCyclesCycleIdRoute =
  AppFinancialsCyclesCycleIdRouteImport.update({
    id: '/cycles/$cycleId',
    path: '/cycles/$cycleId',
    getParentRoute: () => AppFinancialsRoute,
  } as any)
const AppEntryPondPondIdRoute = AppEntryPondPondIdRouteImport.update({
  id: '/entry/pond/$pondId',
  path: '/entry/pond/$pondId',
  getParentRoute: () => AppRoute,
} as any)
const AppEntryPondPondIdWaterRoute = AppEntryPondPondIdWaterRouteImport.update({
  id: '/water',
  path: '/water',
  getParentRoute: () => AppEntryPondPondIdRoute,
} as any)
const AppEntryPondPondIdSamplingRoute =
  AppEntryPondPondIdSamplingRouteImport.update({
    id: '/sampling',
    path: '/sampling',
    getParentRoute: () => AppEntryPondPondIdRoute,
  } as any)
const AppEntryPondPondIdHarvestRoute =
  AppEntryPondPondIdHarvestRouteImport.update({
    id: '/harvest',
    path: '/harvest',
    getParentRoute: () => AppEntryPondPondIdRoute,
  } as any)
const AppEntryPondPondIdFeedingRoute =
  AppEntryPondPondIdFeedingRouteImport.update({
    id: '/feeding',
    path: '/feeding',
    getParentRoute: () => AppEntryPondPondIdRoute,
  } as any)
const AppEntryPondPondIdApplicationRoute =
  AppEntryPondPondIdApplicationRouteImport.update({
    id: '/application',
    path: '/application',
    getParentRoute: () => AppEntryPondPondIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AppAlertsRoute
  '/cycles': typeof AppCyclesRoute
  '/edit-requests': typeof AppEditRequestsRoute
  '/feedings': typeof AppFeedingsRoute
  '/financials': typeof AppFinancialsRouteWithChildren
  '/harvests': typeof AppHarvestsRoute
  '/inventory': typeof AppInventoryRouteWithChildren
  '/map': typeof AppMapRoute
  '/notifications': typeof AppNotificationsRoute
  '/overview': typeof AppOverviewRoute
  '/ponds': typeof AppPondsRouteWithChildren
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/today': typeof AppTodayRoute
  '/entry/batch': typeof AppEntryBatchRoute
  '/entry/overview': typeof AppEntryOverviewRoute
  '/financials/comparison': typeof AppFinancialsComparisonRoute
  '/financials/expenses': typeof AppFinancialsExpensesRoute
  '/import/$jobId': typeof AppImportJobIdRoute
  '/inventory/items': typeof AppInventoryItemsRoute
  '/inventory/transactions': typeof AppInventoryTransactionsRoute
  '/ocr/$jobId': typeof AppOcrJobIdRoute
  '/ocr/test': typeof AppOcrTestRoute
  '/ponds/$pondId': typeof AppPondsPondIdRoute
  '/tools/feed-calculator': typeof AppToolsFeedCalculatorRoute
  '/entry/': typeof AppEntryIndexRoute
  '/financials/': typeof AppFinancialsIndexRoute
  '/import/': typeof AppImportIndexRoute
  '/inventory/': typeof AppInventoryIndexRoute
  '/ocr/': typeof AppOcrIndexRoute
  '/ponds/': typeof AppPondsIndexRoute
  '/entry/pond/$pondId': typeof AppEntryPondPondIdRouteWithChildren
  '/financials/cycles/$cycleId': typeof AppFinancialsCyclesCycleIdRoute
  '/entry/pond/$pondId/application': typeof AppEntryPondPondIdApplicationRoute
  '/entry/pond/$pondId/feeding': typeof AppEntryPondPondIdFeedingRoute
  '/entry/pond/$pondId/harvest': typeof AppEntryPondPondIdHarvestRoute
  '/entry/pond/$pondId/sampling': typeof AppEntryPondPondIdSamplingRoute
  '/entry/pond/$pondId/water': typeof AppEntryPondPondIdWaterRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/alerts': typeof AppAlertsRoute
  '/cycles': typeof AppCyclesRoute
  '/edit-requests': typeof AppEditRequestsRoute
  '/feedings': typeof AppFeedingsRoute
  '/harvests': typeof AppHarvestsRoute
  '/map': typeof AppMapRoute
  '/notifications': typeof AppNotificationsRoute
  '/overview': typeof AppOverviewRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/today': typeof AppTodayRoute
  '/': typeof AppIndexRoute
  '/entry/batch': typeof AppEntryBatchRoute
  '/entry/overview': typeof AppEntryOverviewRoute
  '/financials/comparison': typeof AppFinancialsComparisonRoute
  '/financials/expenses': typeof AppFinancialsExpensesRoute
  '/import/$jobId': typeof AppImportJobIdRoute
  '/inventory/items': typeof AppInventoryItemsRoute
  '/inventory/transactions': typeof AppInventoryTransactionsRoute
  '/ocr/$jobId': typeof AppOcrJobIdRoute
  '/ocr/test': typeof AppOcrTestRoute
  '/ponds/$pondId': typeof AppPondsPondIdRoute
  '/tools/feed-calculator': typeof AppToolsFeedCalculatorRoute
  '/entry': typeof AppEntryIndexRoute
  '/financials': typeof AppFinancialsIndexRoute
  '/import': typeof AppImportIndexRoute
  '/inventory': typeof AppInventoryIndexRoute
  '/ocr': typeof AppOcrIndexRoute
  '/ponds': typeof AppPondsIndexRoute
  '/entry/pond/$pondId': typeof AppEntryPondPondIdRouteWithChildren
  '/financials/cycles/$cycleId': typeof AppFinancialsCyclesCycleIdRoute
  '/entry/pond/$pondId/application': typeof AppEntryPondPondIdApplicationRoute
  '/entry/pond/$pondId/feeding': typeof AppEntryPondPondIdFeedingRoute
  '/entry/pond/$pondId/harvest': typeof AppEntryPondPondIdHarvestRoute
  '/entry/pond/$pondId/sampling': typeof AppEntryPondPondIdSamplingRoute
  '/entry/pond/$pondId/water': typeof AppEntryPondPondIdWaterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/cycles': typeof AppCyclesRoute
  '/_app/edit-requests': typeof AppEditRequestsRoute
  '/_app/feedings': typeof AppFeedingsRoute
  '/_app/financials': typeof AppFinancialsRouteWithChildren
  '/_app/harvests': typeof AppHarvestsRoute
  '/_app/inventory': typeof AppInventoryRouteWithChildren
  '/_app/map': typeof AppMapRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/overview': typeof AppOverviewRoute
  '/_app/ponds': typeof AppPondsRouteWithChildren
  '/_app/reports': typeof AppReportsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/today': typeof AppTodayRoute
  '/_app/': typeof AppIndexRoute
  '/_app/entry/batch': typeof AppEntryBatchRoute
  '/_app/entry/overview': typeof AppEntryOverviewRoute
  '/_app/financials/comparison': typeof AppFinancialsComparisonRoute
  '/_app/financials/expenses': typeof AppFinancialsExpensesRoute
  '/_app/import/$jobId': typeof AppImportJobIdRoute
  '/_app/inventory/items': typeof AppInventoryItemsRoute
  '/_app/inventory/transactions': typeof AppInventoryTransactionsRoute
  '/_app/ocr/$jobId': typeof AppOcrJobIdRoute
  '/_app/ocr/test': typeof AppOcrTestRoute
  '/_app/ponds/$pondId': typeof AppPondsPondIdRoute
  '/_app/tools/feed-calculator': typeof AppToolsFeedCalculatorRoute
  '/_app/entry/': typeof AppEntryIndexRoute
  '/_app/financials/': typeof AppFinancialsIndexRoute
  '/_app/import/': typeof AppImportIndexRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
  '/_app/ocr/': typeof AppOcrIndexRoute
  '/_app/ponds/': typeof AppPondsIndexRoute
  '/_app/entry/pond/$pondId': typeof AppEntryPondPondIdRouteWithChildren
  '/_app/financials/cycles/$cycleId': typeof AppFinancialsCyclesCycleIdRoute
  '/_app/entry/pond/$pondId/application': typeof AppEntryPondPondIdApplicationRoute
  '/_app/entry/pond/$pondId/feeding': typeof AppEntryPondPondIdFeedingRoute
  '/_app/entry/pond/$pondId/harvest': typeof AppEntryPondPondIdHarvestRoute
  '/_app/entry/pond/$pondId/sampling': typeof AppEntryPondPondIdSamplingRoute
  '/_app/entry/pond/$pondId/water': typeof AppEntryPondPondIdWaterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/alerts'
    | '/cycles'
    | '/edit-requests'
    | '/feedings'
    | '/financials'
    | '/harvests'
    | '/inventory'
    | '/map'
    | '/notifications'
    | '/overview'
    | '/ponds'
    | '/reports'
    | '/settings'
    | '/today'
    | '/entry/batch'
    | '/entry/overview'
    | '/financials/comparison'
    | '/financials/expenses'
    | '/import/$jobId'
    | '/inventory/items'
    | '/inventory/transactions'
    | '/ocr/$jobId'
    | '/ocr/test'
    | '/ponds/$pondId'
    | '/tools/feed-calculator'
    | '/entry/'
    | '/financials/'
    | '/import/'
    | '/inventory/'
    | '/ocr/'
    | '/ponds/'
    | '/entry/pond/$pondId'
    | '/financials/cycles/$cycleId'
    | '/entry/pond/$pondId/application'
    | '/entry/pond/$pondId/feeding'
    | '/entry/pond/$pondId/harvest'
    | '/entry/pond/$pondId/sampling'
    | '/entry/pond/$pondId/water'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/alerts'
    | '/cycles'
    | '/edit-requests'
    | '/feedings'
    | '/harvests'
    | '/map'
    | '/notifications'
    | '/overview'
    | '/reports'
    | '/settings'
    | '/today'
    | '/'
    | '/entry/batch'
    | '/entry/overview'
    | '/financials/comparison'
    | '/financials/expenses'
    | '/import/$jobId'
    | '/inventory/items'
    | '/inventory/transactions'
    | '/ocr/$jobId'
    | '/ocr/test'
    | '/ponds/$pondId'
    | '/tools/feed-calculator'
    | '/entry'
    | '/financials'
    | '/import'
    | '/inventory'
    | '/ocr'
    | '/ponds'
    | '/entry/pond/$pondId'
    | '/financials/cycles/$cycleId'
    | '/entry/pond/$pondId/application'
    | '/entry/pond/$pondId/feeding'
    | '/entry/pond/$pondId/harvest'
    | '/entry/pond/$pondId/sampling'
    | '/entry/pond/$pondId/water'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/alerts'
    | '/_app/cycles'
    | '/_app/edit-requests'
    | '/_app/feedings'
    | '/_app/financials'
    | '/_app/harvests'
    | '/_app/inventory'
    | '/_app/map'
    | '/_app/notifications'
    | '/_app/overview'
    | '/_app/ponds'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/today'
    | '/_app/'
    | '/_app/entry/batch'
    | '/_app/entry/overview'
    | '/_app/financials/comparison'
    | '/_app/financials/expenses'
    | '/_app/import/$jobId'
    | '/_app/inventory/items'
    | '/_app/inventory/transactions'
    | '/_app/ocr/$jobId'
    | '/_app/ocr/test'
    | '/_app/ponds/$pondId'
    | '/_app/tools/feed-calculator'
    | '/_app/entry/'
    | '/_app/financials/'
    | '/_app/import/'
    | '/_app/inventory/'
    | '/_app/ocr/'
    | '/_app/ponds/'
    | '/_app/entry/pond/$pondId'
    | '/_app/financials/cycles/$cycleId'
    | '/_app/entry/pond/$pondId/application'
    | '/_app/entry/pond/$pondId/feeding'
    | '/_app/entry/pond/$pondId/harvest'
    | '/_app/entry/pond/$pondId/sampling'
    | '/_app/entry/pond/$pondId/water'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ponds': {
      id: '/_app/ponds'
      path: '/ponds'
      fullPath: '/ponds'
      preLoaderRoute: typeof AppPondsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/overview': {
      id: '/_app/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/map': {
      id: '/_app/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/harvests': {
      id: '/_app/harvests'
      path: '/harvests'
      fullPath: '/harvests'
      preLoaderRoute: typeof AppHarvestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financials': {
      id: '/_app/financials'
      path: '/financials'
      fullPath: '/financials'
      preLoaderRoute: typeof AppFinancialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedings': {
      id: '/_app/feedings'
      path: '/feedings'
      fullPath: '/feedings'
      preLoaderRoute: typeof AppFeedingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/edit-requests': {
      id: '/_app/edit-requests'
      path: '/edit-requests'
      fullPath: '/edit-requests'
      preLoaderRoute: typeof AppEditRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cycles': {
      id: '/_app/cycles'
      path: '/cycles'
      fullPath: '/cycles'
      preLoaderRoute: typeof AppCyclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ponds/': {
      id: '/_app/ponds/'
      path: '/'
      fullPath: '/ponds/'
      preLoaderRoute: typeof AppPondsIndexRouteImport
      parentRoute: typeof AppPondsRoute
    }
    '/_app/ocr/': {
      id: '/_app/ocr/'
      path: '/ocr'
      fullPath: '/ocr/'
      preLoaderRoute: typeof AppOcrIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/import/': {
      id: '/_app/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof AppImportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financials/': {
      id: '/_app/financials/'
      path: '/'
      fullPath: '/financials/'
      preLoaderRoute: typeof AppFinancialsIndexRouteImport
      parentRoute: typeof AppFinancialsRoute
    }
    '/_app/entry/': {
      id: '/_app/entry/'
      path: '/entry'
      fullPath: '/entry/'
      preLoaderRoute: typeof AppEntryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tools/feed-calculator': {
      id: '/_app/tools/feed-calculator'
      path: '/tools/feed-calculator'
      fullPath: '/tools/feed-calculator'
      preLoaderRoute: typeof AppToolsFeedCalculatorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ponds/$pondId': {
      id: '/_app/ponds/$pondId'
      path: '/$pondId'
      fullPath: '/ponds/$pondId'
      preLoaderRoute: typeof AppPondsPondIdRouteImport
      parentRoute: typeof AppPondsRoute
    }
    '/_app/ocr/test': {
      id: '/_app/ocr/test'
      path: '/ocr/test'
      fullPath: '/ocr/test'
      preLoaderRoute: typeof AppOcrTestRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ocr/$jobId': {
      id: '/_app/ocr/$jobId'
      path: '/ocr/$jobId'
      fullPath: '/ocr/$jobId'
      preLoaderRoute: typeof AppOcrJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/transactions': {
      id: '/_app/inventory/transactions'
      path: '/transactions'
      fullPath: '/inventory/transactions'
      preLoaderRoute: typeof AppInventoryTransactionsRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/items': {
      id: '/_app/inventory/items'
      path: '/items'
      fullPath: '/inventory/items'
      preLoaderRoute: typeof AppInventoryItemsRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/import/$jobId': {
      id: '/_app/import/$jobId'
      path: '/import/$jobId'
      fullPath: '/import/$jobId'
      preLoaderRoute: typeof AppImportJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financials/expenses': {
      id: '/_app/financials/expenses'
      path: '/expenses'
      fullPath: '/financials/expenses'
      preLoaderRoute: typeof AppFinancialsExpensesRouteImport
      parentRoute: typeof AppFinancialsRoute
    }
    '/_app/financials/comparison': {
      id: '/_app/financials/comparison'
      path: '/comparison'
      fullPath: '/financials/comparison'
      preLoaderRoute: typeof AppFinancialsComparisonRouteImport
      parentRoute: typeof AppFinancialsRoute
    }
    '/_app/entry/overview': {
      id: '/_app/entry/overview'
      path: '/entry/overview'
      fullPath: '/entry/overview'
      preLoaderRoute: typeof AppEntryOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entry/batch': {
      id: '/_app/entry/batch'
      path: '/entry/batch'
      fullPath: '/entry/batch'
      preLoaderRoute: typeof AppEntryBatchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financials/cycles/$cycleId': {
      id: '/_app/financials/cycles/$cycleId'
      path: '/cycles/$cycleId'
      fullPath: '/financials/cycles/$cycleId'
      preLoaderRoute: typeof AppFinancialsCyclesCycleIdRouteImport
      parentRoute: typeof AppFinancialsRoute
    }
    '/_app/entry/pond/$pondId': {
      id: '/_app/entry/pond/$pondId'
      path: '/entry/pond/$pondId'
      fullPath: '/entry/pond/$pondId'
      preLoaderRoute: typeof AppEntryPondPondIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entry/pond/$pondId/water': {
      id: '/_app/entry/pond/$pondId/water'
      path: '/water'
      fullPath: '/entry/pond/$pondId/water'
      preLoaderRoute: typeof AppEntryPondPondIdWaterRouteImport
      parentRoute: typeof AppEntryPondPondIdRoute
    }
    '/_app/entry/pond/$pondId/sampling': {
      id: '/_app/entry/pond/$pondId/sampling'
      path: '/sampling'
      fullPath: '/entry/pond/$pondId/sampling'
      preLoaderRoute: typeof AppEntryPondPondIdSamplingRouteImport
      parentRoute: typeof AppEntryPondPondIdRoute
    }
    '/_app/entry/pond/$pondId/harvest': {
      id: '/_app/entry/pond/$pondId/harvest'
      path: '/harvest'
      fullPath: '/entry/pond/$pondId/harvest'
      preLoaderRoute: typeof AppEntryPondPondIdHarvestRouteImport
      parentRoute: typeof AppEntryPondPondIdRoute
    }
    '/_app/entry/pond/$pondId/feeding': {
      id: '/_app/entry/pond/$pondId/feeding'
      path: '/feeding'
      fullPath: '/entry/pond/$pondId/feeding'
      preLoaderRoute: typeof AppEntryPondPondIdFeedingRouteImport
      parentRoute: typeof AppEntryPondPondIdRoute
    }
    '/_app/entry/pond/$pondId/application': {
      id: '/_app/entry/pond/$pondId/application'
      path: '/application'
      fullPath: '/entry/pond/$pondId/application'
      preLoaderRoute: typeof AppEntryPondPondIdApplicationRouteImport
      parentRoute: typeof AppEntryPondPondIdRoute
    }
  }
}

interface AppFinancialsRouteChildren {
  AppFinancialsComparisonRoute: typeof AppFinancialsComparisonRoute
  AppFinancialsExpensesRoute: typeof AppFinancialsExpensesRoute
  AppFinancialsIndexRoute: typeof AppFinancialsIndexRoute
  AppFinancialsCyclesCycleIdRoute: typeof AppFinancialsCyclesCycleIdRoute
}

const AppFinancialsRouteChildren: AppFinancialsRouteChildren = {
  AppFinancialsComparisonRoute: AppFinancialsComparisonRoute,
  AppFinancialsExpensesRoute: AppFinancialsExpensesRoute,
  AppFinancialsIndexRoute: AppFinancialsIndexRoute,
  AppFinancialsCyclesCycleIdRoute: AppFinancialsCyclesCycleIdRoute,
}

const AppFinancialsRouteWithChildren = AppFinancialsRoute._addFileChildren(
  AppFinancialsRouteChildren,
)

interface AppInventoryRouteChildren {
  AppInventoryItemsRoute: typeof AppInventoryItemsRoute
  AppInventoryTransactionsRoute: typeof AppInventoryTransactionsRoute
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
}

const AppInventoryRouteChildren: AppInventoryRouteChildren = {
  AppInventoryItemsRoute: AppInventoryItemsRoute,
  AppInventoryTransactionsRoute: AppInventoryTransactionsRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
}

const AppInventoryRouteWithChildren = AppInventoryRoute._addFileChildren(
  AppInventoryRouteChildren,
)

interface AppPondsRouteChildren {
  AppPondsPondIdRoute: typeof AppPondsPondIdRoute
  AppPondsIndexRoute: typeof AppPondsIndexRoute
}

const AppPondsRouteChildren: AppPondsRouteChildren = {
  AppPondsPondIdRoute: AppPondsPondIdRoute,
  AppPondsIndexRoute: AppPondsIndexRoute,
}

const AppPondsRouteWithChildren = AppPondsRoute._addFileChildren(
  AppPondsRouteChildren,
)

interface AppEntryPondPondIdRouteChildren {
  AppEntryPondPondIdApplicationRoute: typeof AppEntryPondPondIdApplicationRoute
  AppEntryPondPondIdFeedingRoute: typeof AppEntryPondPondIdFeedingRoute
  AppEntryPondPondIdHarvestRoute: typeof AppEntryPondPondIdHarvestRoute
  AppEntryPondPondIdSamplingRoute: typeof AppEntryPondPondIdSamplingRoute
  AppEntryPondPondIdWaterRoute: typeof AppEntryPondPondIdWaterRoute
}

const AppEntryPondPondIdRouteChildren: AppEntryPondPondIdRouteChildren = {
  AppEntryPondPondIdApplicationRoute: AppEntryPondPondIdApplicationRoute,
  AppEntryPondPondIdFeedingRoute: AppEntryPondPondIdFeedingRoute,
  AppEntryPondPondIdHarvestRoute: AppEntryPondPondIdHarvestRoute,
  AppEntryPondPondIdSamplingRoute: AppEntryPondPondIdSamplingRoute,
  AppEntryPondPondIdWaterRoute: AppEntryPondPondIdWaterRoute,
}

const AppEntryPondPondIdRouteWithChildren =
  AppEntryPondPondIdRoute._addFileChildren(AppEntryPondPondIdRouteChildren)

interface AppRouteChildren {
  AppAlertsRoute: typeof AppAlertsRoute
  AppCyclesRoute: typeof AppCyclesRoute
  AppEditRequestsRoute: typeof AppEditRequestsRoute
  AppFeedingsRoute: typeof AppFeedingsRoute
  AppFinancialsRoute: typeof AppFinancialsRouteWithChildren
  AppHarvestsRoute: typeof AppHarvestsRoute
  AppInventoryRoute: typeof AppInventoryRouteWithChildren
  AppMapRoute: typeof AppMapRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOverviewRoute: typeof AppOverviewRoute
  AppPondsRoute: typeof AppPondsRouteWithChildren
  AppReportsRoute: typeof AppReportsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTodayRoute: typeof AppTodayRoute
  AppIndexRoute: typeof AppIndexRoute
  AppEntryBatchRoute: typeof AppEntryBatchRoute
  AppEntryOverviewRoute: typeof AppEntryOverviewRoute
  AppImportJobIdRoute: typeof AppImportJobIdRoute
  AppOcrJobIdRoute: typeof AppOcrJobIdRoute
  AppOcrTestRoute: typeof AppOcrTestRoute
  AppToolsFeedCalculatorRoute: typeof AppToolsFeedCalculatorRoute
  AppEntryIndexRoute: typeof AppEntryIndexRoute
  AppImportIndexRoute: typeof AppImportIndexRoute
  AppOcrIndexRoute: typeof AppOcrIndexRoute
  AppEntryPondPondIdRoute: typeof AppEntryPondPondIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsRoute: AppAlertsRoute,
  AppCyclesRoute: AppCyclesRoute,
  AppEditRequestsRoute: AppEditRequestsRoute,
  AppFeedingsRoute: AppFeedingsRoute,
  AppFinancialsRoute: AppFinancialsRouteWithChildren,
  AppHarvestsRoute: AppHarvestsRoute,
  AppInventoryRoute: AppInventoryRouteWithChildren,
  AppMapRoute: AppMapRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOverviewRoute: AppOverviewRoute,
  AppPondsRoute: AppPondsRouteWithChildren,
  AppReportsRoute: AppReportsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTodayRoute: AppTodayRoute,
  AppIndexRoute: AppIndexRoute,
  AppEntryBatchRoute: AppEntryBatchRoute,
  AppEntryOverviewRoute: AppEntryOverviewRoute,
  AppImportJobIdRoute: AppImportJobIdRoute,
  AppOcrJobIdRoute: AppOcrJobIdRoute,
  AppOcrTestRoute: AppOcrTestRoute,
  AppToolsFeedCalculatorRoute: AppToolsFeedCalculatorRoute,
  AppEntryIndexRoute: AppEntryIndexRoute,
  AppImportIndexRoute: AppImportIndexRoute,
  AppOcrIndexRoute: AppOcrIndexRoute,
  AppEntryPondPondIdRoute: AppEntryPondPondIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
